import apiClient from "../common";

export type ForecastListItem = {
  id: number;
  forecasted_date: string;
  product_code: string;
  segment: string | null;
  client_code: string | null;
  client_master: string | null;
  units: number;
};

export type ForecastListResponse = {
  count: number;
  page: number;
  page_size: number;
  results: ForecastListItem[];
};

export type ForecastListParams = {
  date_from?: string;
  date_to?: string;
  page?: number;
  page_size?: number;
};

export const ApiForecastList = async (params: ForecastListParams = {}) => {
  const search = new URLSearchParams();
  if (params.date_from) {
    search.set("date_from", params.date_from);
  }
  if (params.date_to) {
    search.set("date_to", params.date_to);
  }
  if (params.page != null) {
    search.set("page", String(params.page));
  }
  if (params.page_size != null) {
    search.set("page_size", String(params.page_size));
  }
  const qs = search.toString();
  const suffix = qs ? `?${qs}` : "";
  return await apiClient.get<ForecastListResponse>(
    `coverage_simulator/products/forecast/list/${suffix}`,
    { withCredentials: true },
  );
};
